import fetch from '@/hooks/fetch';
import actions from '../constants';

export default {
  useFetchCohort: ({ category, code, isNew }, readStatus) => fetch.useFetchDispatch(
    actions.FETCH_COHORT,
    readStatus,
    { category, code, isNew },
  ),
};
